import createIcon from '@/lib/create-icon'

const HandballIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      fill='none'
      d='M13.8092 23C11.9489 20.8616 10.8225 18.0678 10.8225 15.011C10.8225 8.28554 16.2746 2.8335 23 2.8335C29.7254 2.8335 35.1775 8.28554 35.1775 15.011C35.1775 17.245 34.5759 19.3386 33.5258 21.1385'
      stroke='url(#paint0_linear_5307_2561)'
      strokeWidth='1.82662'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M13.8092 23C11.9489 20.8616 10.8225 18.0678 10.8225 15.011C10.8225 8.28554 16.2746 2.8335 23 2.8335C29.7254 2.8335 35.1775 8.28554 35.1775 15.011C35.1775 17.245 34.5759 19.3386 33.5258 21.1385'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='1.82662'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M13.8092 23C11.9489 20.8616 10.8225 18.0678 10.8225 15.011C10.8225 8.28554 16.2746 2.8335 23 2.8335C29.7254 2.8335 35.1775 8.28554 35.1775 15.011C35.1775 17.245 34.5759 19.3386 33.5258 21.1385'
      stroke='url(#paint1_radial_5307_2561)'
      strokeOpacity='0.6'
      strokeWidth='1.82662'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M18.2758 4.05127C17.7328 6.02286 17.8414 10.8533 22.6195 14.4021C28.6377 12.7825 32.8943 13.367 35.1776 15.437'
      stroke='url(#paint2_linear_5307_2561)'
      strokeWidth='1.82662'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M18.2758 4.05127C17.7328 6.02286 17.8414 10.8533 22.6195 14.4021C28.6377 12.7825 32.8943 13.367 35.1776 15.437'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='1.82662'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M18.2758 4.05127C17.7328 6.02286 17.8414 10.8533 22.6195 14.4021C28.6377 12.7825 32.8943 13.367 35.1776 15.437'
      stroke='url(#paint3_radial_5307_2561)'
      strokeOpacity='0.6'
      strokeWidth='1.82662'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M19.3467 11.0707C21.8881 8.77363 29.0865 7.67236 34.1692 9.9692'
      stroke='url(#paint4_linear_5307_2561)'
      strokeWidth='1.82662'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M19.3467 11.0707C21.8881 8.77363 29.0865 7.67236 34.1692 9.9692'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='1.82662'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M19.3467 11.0707C21.8881 8.77363 29.0865 7.67236 34.1692 9.9692'
      stroke='url(#paint5_radial_5307_2561)'
      strokeOpacity='0.6'
      strokeWidth='1.82662'
      strokeLinejoin='round'
    />
    <path
      stroke='none'
      d='M27.2331 17.659C27.1108 18.1484 27.4083 18.6442 27.8976 18.7666C28.387 18.8889 28.8828 18.5914 29.0052 18.102L27.2331 17.659ZM28.0518 13.6439C27.6868 15.8497 27.6916 15.8251 27.2331 17.659L29.0052 18.102C29.4775 16.2129 29.4822 16.1883 29.8539 13.9421L28.0518 13.6439Z'
      fill='url(#paint6_linear_5307_2561)'
    />
    <path
      stroke='none'
      d='M27.2331 17.659C27.1108 18.1484 27.4083 18.6442 27.8976 18.7666C28.387 18.8889 28.8828 18.5914 29.0052 18.102L27.2331 17.659ZM28.0518 13.6439C27.6868 15.8497 27.6916 15.8251 27.2331 17.659L29.0052 18.102C29.4775 16.2129 29.4822 16.1883 29.8539 13.9421L28.0518 13.6439Z'
      fill='white'
      fillOpacity='0.04'
    />
    <path
      stroke='none'
      d='M27.2331 17.659C27.1108 18.1484 27.4083 18.6442 27.8976 18.7666C28.387 18.8889 28.8828 18.5914 29.0052 18.102L27.2331 17.659ZM28.0518 13.6439C27.6868 15.8497 27.6916 15.8251 27.2331 17.659L29.0052 18.102C29.4775 16.2129 29.4822 16.1883 29.8539 13.9421L28.0518 13.6439Z'
      fill='url(#paint7_radial_5307_2561)'
      fillOpacity='0.6'
    />
    <path
      fill='none'
      d='M17.4154 18.3462C15.5538 16.0192 13.4509 13.744 13.2581 7.70459'
      stroke='url(#paint8_linear_5307_2561)'
      strokeWidth='1.82662'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M17.4154 18.3462C15.5538 16.0192 13.4509 13.744 13.2581 7.70459'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='1.82662'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M17.4154 18.3462C15.5538 16.0192 13.4509 13.744 13.2581 7.70459'
      stroke='url(#paint9_radial_5307_2561)'
      strokeOpacity='0.6'
      strokeWidth='1.82662'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M18.0169 33.7776V23.5859C18.0169 22.5902 18.8152 21.783 19.8001 21.783C20.7849 21.783 21.5833 22.5899 21.5833 23.5856M21.5833 29.5691V21.8029C21.5833 20.8072 22.3816 20 23.3666 20C24.3514 20 25.1498 20.8072 25.1498 21.8029V30.8068M25.1498 24.1719C25.1498 23.1717 25.9886 22.3614 26.9779 22.3614C27.9671 22.3614 28.7692 23.1722 28.7692 24.1724V31.9987M28.7692 26.6187C28.7692 25.6307 29.5615 24.8259 30.5387 24.8259C31.516 24.8259 32.3083 25.6269 32.3083 26.6149V36.9495C32.3083 38.1889 31.8574 39.5721 30.4869 41.2214C30.0901 41.699 29.8432 42.2919 29.8432 42.9157V44M18.0169 28.2275C17.0177 29.1647 14.5964 31.6389 13.9319 33.0118C13.2674 34.3848 14.2553 36.0066 14.6707 36.6418L18.0164 41.0906C18.3324 41.5108 18.5035 42.0242 18.5035 42.5522V44'
      stroke='url(#paint10_linear_5307_2561)'
      strokeWidth='1.8'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M18.0169 33.7776V23.5859C18.0169 22.5902 18.8152 21.783 19.8001 21.783C20.7849 21.783 21.5833 22.5899 21.5833 23.5856M21.5833 29.5691V21.8029C21.5833 20.8072 22.3816 20 23.3666 20C24.3514 20 25.1498 20.8072 25.1498 21.8029V30.8068M25.1498 24.1719C25.1498 23.1717 25.9886 22.3614 26.9779 22.3614C27.9671 22.3614 28.7692 23.1722 28.7692 24.1724V31.9987M28.7692 26.6187C28.7692 25.6307 29.5615 24.8259 30.5387 24.8259C31.516 24.8259 32.3083 25.6269 32.3083 26.6149V36.9495C32.3083 38.1889 31.8574 39.5721 30.4869 41.2214C30.0901 41.699 29.8432 42.2919 29.8432 42.9157V44M18.0169 28.2275C17.0177 29.1647 14.5964 31.6389 13.9319 33.0118C13.2674 34.3848 14.2553 36.0066 14.6707 36.6418L18.0164 41.0906C18.3324 41.5108 18.5035 42.0242 18.5035 42.5522V44'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='1.8'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M18.0169 33.7776V23.5859C18.0169 22.5902 18.8152 21.783 19.8001 21.783C20.7849 21.783 21.5833 22.5899 21.5833 23.5856M21.5833 29.5691V21.8029C21.5833 20.8072 22.3816 20 23.3666 20C24.3514 20 25.1498 20.8072 25.1498 21.8029V30.8068M25.1498 24.1719C25.1498 23.1717 25.9886 22.3614 26.9779 22.3614C27.9671 22.3614 28.7692 23.1722 28.7692 24.1724V31.9987M28.7692 26.6187C28.7692 25.6307 29.5615 24.8259 30.5387 24.8259C31.516 24.8259 32.3083 25.6269 32.3083 26.6149V36.9495C32.3083 38.1889 31.8574 39.5721 30.4869 41.2214C30.0901 41.699 29.8432 42.2919 29.8432 42.9157V44M18.0169 28.2275C17.0177 29.1647 14.5964 31.6389 13.9319 33.0118C13.2674 34.3848 14.2553 36.0066 14.6707 36.6418L18.0164 41.0906C18.3324 41.5108 18.5035 42.0242 18.5035 42.5522V44'
      stroke='url(#paint11_radial_5307_2561)'
      strokeOpacity='0.6'
      strokeWidth='1.8'
      strokeLinecap='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5307_2561'
        x1='10.8225'
        y1='2.8335'
        x2='35.0497'
        y2='23.1523'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5307_2561'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23 23) scale(12.1775 10.2695)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_5307_2561'
        x1='18.053'
        y1='4.05127'
        x2='31.9304'
        y2='18.5459'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_5307_2561'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(26.6153 15.437) scale(8.5623 5.79802)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint4_linear_5307_2561'
        x1='19.3467'
        y1='8.70166'
        x2='20.6101'
        y2='14.1913'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint5_radial_5307_2561'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(26.7579 11.0707) scale(7.41127 1.2064)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint6_linear_5307_2561'
        x1='28.1191'
        y1='13.793'
        x2='29.5041'
        y2='13.9891'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint7_radial_5307_2561'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(28.536 17.8805) scale(0.416867 2.08154)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint8_linear_5307_2561'
        x1='13.2581'
        y1='7.70459'
        x2='19.8195'
        y2='9.48469'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint9_radial_5307_2561'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(15.3367 18.3462) scale(2.07866 5.41908)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint10_linear_5307_2561'
        x1='13.7083'
        y1='20'
        x2='38.1463'
        y2='33.1525'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint11_radial_5307_2561'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23.0083 44) scale(9.3 12.2217)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'HandballIcon'
)

export default HandballIcon
